module.exports = __webpack_public_path__ + "img/iglo.7d37eaa3.jpg";